const NON_BREAKING_SPACE = '\u00A0'

export const getStringValuesJoinedByNonBreakingSpace = (
  values: string[],
): string => values.join(NON_BREAKING_SPACE)
